import { render, staticRenderFns } from "./DepartmentMultiplePickerInput.vue?vue&type=template&id=68785804&scoped=true&"
import script from "./DepartmentMultiplePickerInput.vue?vue&type=script&lang=js&"
export * from "./DepartmentMultiplePickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68785804",
  null
  
)

export default component.exports